import { useNavigate, useOutletContext } from "react-router-dom";
import { BidDecisionGroup, Customer, DecisionEnum } from "@/graphql/__generated__/graphql";
import { FormGroupHeader } from "@/components/shared";
import { ActionButtonConfig } from "@/components/shared/FormGroupHeader";
import { EditTenderContext } from "@/layouts/EditTenderLayout";
import AddMobileService from "./Form";
import { useTranslation } from "react-i18next";
import { JSX, useState } from "react";

/**
 * Add Service component. Acts as a wrapper for the AddMobileService form.
 *
 * @returns {JSX.Element}
 */
const AddMobileServiceComponent = (): JSX.Element => {

  // Hooks
  const navigate = useNavigate();
  const { t } = useTranslation(["translation", "common"]);
  const { tenderByIdData } = useOutletContext<EditTenderContext>();
  const [isLoading, setIsLoading] = useState(false);

  // Constants
  const customer: Customer = tenderByIdData.fetchTenderById.customer;
  const biddingOperationalOrganizations: Partial<BidDecisionGroup>[] = tenderByIdData.fetchTenderById.bidDecisionGroups.filter(
    (group) => group.currentDecision === DecisionEnum.Bid
  );
  const isDevMode = import.meta.env.VITE_APP_ENV === "dev";

  /**
   * OnClick handler for the Back button
  */
  const handleBackClick = () => navigate(-1);

  /**
   * OnClick handler for the Prefill Mock Data button
   */
  const handlePrefillMockData = () => {
    // This will be handled by the form component
    const formElement = document.getElementById("add-mobile-service-form") as HTMLFormElement;
    if (formElement) {
      // Trigger a custom event that the form can listen to
      formElement.dispatchEvent(new CustomEvent("prefillMockData"));
    }
  };

  // Action buttons for FormGroupHeader
  const actionButtons: ActionButtonConfig[] = [
    isDevMode ? {
      text: "Prefill Mock Data",
      actionFn: handlePrefillMockData,
      variant: "outline",
      disabled: isLoading,
    } : undefined,
    {
      text: t("common:buttons.back"),
      actionFn: handleBackClick,
      variant: "outline",
      disabled: isLoading,
    },
    {
      text: t("common:buttons.submit"),
      type: "submit",
      form: "add-mobile-service-form",
      loading: isLoading,
    }
  ].filter(Boolean) as ActionButtonConfig[];

  return (
    <>
      <FormGroupHeader
        actionButtons={actionButtons}
        title={t("mobileservice.newtitle")}
        description={t("mobileservice.newdescription")}
        className="pr-4 pl-2"
      />
      <div className="pr-4 pl-2 pb-[300px]">
        <AddMobileService customer={customer} biddingOperationalOrganizations={biddingOperationalOrganizations} setIsLoading={setIsLoading} />
      </div>
    </>
  );
};

export default AddMobileServiceComponent;
